import Axios from 'axios'
import BaseResponsesObject from "./helpers/initResponsesObject"
import { stateMerge } from "vue-object-merge"

const CandidateStore = {
    namespaced: true,
    state: {
        status: '',
        candidate_jwt: localStorage.getItem('candidate_jwt') || '',
        evaluation_id: localStorage.getItem('candidate_eval') || '',
        candidateEval: {},
        sight1Survey: { questions: {} },
        sight2Survey: { questions: {} },
        sight1Responses: {},
        sight2Responses: {},
        results: {},
        campaignEval: {
            candidate_first_name: "",
            candidate_last_name: "",
            candidate_email: "",
            profile_link: "",
            docs_ids: []
        },
        campaignPosition: {}
    },
    mutations: {
        auth_request(state){
            state.status = 'loading'
        },
        auth_success(state, loginData){
            state.candidate_jwt = loginData.jwt
            if(loginData.evaluation){
                state.candidateEval = loginData.evaluation
                localStorage.setItem('locale', loginData.evaluation.language)
                setTimeout(function(){
                    if(state.candidateEval.completed ){
                        state.status = 'alreadyCompleted'
                    }else{
                        state.status = 'success'
                    }
                }, 1000);
            }else{
                state.campaignPosition = loginData.sight_group
                localStorage.setItem('locale', loginData.sight_group.language)
                setTimeout(function(){
                    if(state.campaignPosition.campaign_open ){
                        state.status = 'success'
                    }else{
                        state.status = 'campaignClosed'
                    }
                }, 1000);
            }

            
        },
        auth_error(state){
            state.status = 'error'
        },
        getSurveys(state, surveyData){
            state.sight1Survey = surveyData.sight1
            state.sight2Survey = surveyData.sight2
            state.sight1Responses = BaseResponsesObject.sight1()
            state.sight2Responses = BaseResponsesObject.sight2()
        },
        saveResponses(state, responsesData){
            if(responsesData.surveyName == 'sight1'){ stateMerge(state.sight1Responses, responsesData.survey) }
            if(responsesData.surveyName == 'sight2'){ stateMerge(state.sight2Responses, responsesData.survey) }
        },
        setCompleted(state, responsesData){
            state.status = 'finish'
            state.results = responsesData
        },
        updateCampaignData(state, campaignData){
            state.campaignEval = campaignData
        },
        updateEvalFiles(state, campaignData){
            stateMerge(state.campaignEval, campaignData)
        },
    },
    actions: {
        login: login,
        getSurveys: getSurveys,
        saveEval: saveEval,
        campaign_login: campaign_login,
        saveCampaignEval: saveCampaignEval
    }
}


function saveEval(context, surveyData){
    setCandidateJwt()
    const evalId = context.state.candidateEval.id
    const params = {
        user_id: context.state.candidateEval.user_id,
        evaluation: {
            survey_time: surveyData.elapsedTime,
            candidate_genre: surveyData.genre,
        },
        sight_test: {
            sight1_responses: context.state.sight1Responses,
            sight2_responses: context.state.sight2Responses,
        }
    }
    return Axios.put(`${this.sightApiBaseUrl}surveys/${evalId}`, params).then(resp => {
        context.commit('setCompleted', resp.data)
        return resp
    }).catch(err => {
        console.log("RefsStore/saveEval error", err)
    })
}

function getSurveys(context){
    setCandidateJwt()
    Axios.get(`${this.sightApiBaseUrl}surveys/`).then(resp => {
        context.commit('getSurveys', resp.data)
    }).catch(err => {
        console.log("RefsStore/Index error", err)
    })
}

function login(context, guestToken){

    context.commit('auth_request')

    const data = {
        guest_token: guestToken,
        guest_type: 'candidate',
        client_id: process.env.VUE_APP_AXIOS_API_ID,
        api_secret: process.env.VUE_APP_AXIOS_API_SECRET
    }
    return Axios.post(`iapp_api/${process.env.VUE_APP_AXIOS_API_ID}/v1/auth/`, data).then(resp => {

        const jwt = resp.data.jwt
        const evaluation = resp.data.evaluation

        localStorage.setItem('candidate_jwt', jwt)
        localStorage.setItem('evaluation', JSON.stringify(evaluation))

        Axios.defaults.headers.common['Authorization'] = jwt

        context.commit('auth_success', resp.data)
        return resp.data

    }).catch(err => {
        console.log("Auth failure", err)
        context.commit('auth_error')
        localStorage.removeItem('candidate_jwt')
        localStorage.removeItem('evaluation')
    })

}


function campaign_login(context, guestToken){

    context.commit('auth_request')

    const data = {
        guest_token: guestToken,
        guest_type: 'campaign',
        client_id: process.env.VUE_APP_AXIOS_API_ID,
        api_secret: process.env.VUE_APP_AXIOS_API_SECRET
    }
    return Axios.post(`iapp_api/${process.env.VUE_APP_AXIOS_API_ID}/v1/auth/`, data).then(resp => {

        const jwt = resp.data.jwt
        const sight_group = resp.data.sight_group

        localStorage.setItem('candidate_jwt', jwt)

        Axios.defaults.headers.common['Authorization'] = jwt

        context.commit('auth_success', resp.data)
        return resp.data

    }).catch(err => {
        console.log("Auth failure", err)
        context.commit('auth_error')
        localStorage.removeItem('candidate_jwt')
        localStorage.removeItem('evaluation')
    })
}

function saveCampaignEval(context, surveyData){
    setCandidateJwt()
    const evalId = context.state.candidateEval.id
    const params = {
        language: context.state.campaignPosition.language,
        user_id: context.state.campaignPosition.user_id,
        sight_group_id: context.state.campaignPosition.id,
        evaluation: {
            candidate_first_name: context.state.campaignEval.candidate_first_name,
            candidate_last_name: context.state.campaignEval.candidate_last_name,
            candidate_email: context.state.campaignEval.candidate_email,
            docs_ids: context.state.campaignEval.docs_ids,
            survey_time: surveyData.elapsedTime,
            campaign_eval: true,
            candidate_genre: surveyData.genre,
            profile_link: context.state.campaignEval.profile_link,
        },
        sight_test: {
            sight1_responses: context.state.sight1Responses,
            sight2_responses: context.state.sight2Responses,
        }
    }
    return Axios.post(`${this.sightApiBaseUrl}surveys/`, params).then(resp => {
        context.commit('setCompleted', resp.data)
        return resp
    }).catch(err => {
        console.log("RefsStore/saveEval error", err)
    })
}

function setCandidateJwt(){
    // Set JWT if present
    const jwt = localStorage.getItem('candidate_jwt')
    if (jwt) { Axios.defaults.headers.common['Authorization'] = "Bearer " + jwt }
}

export default CandidateStore